import { useCallback } from "react";
import { useGetFlag } from "./useGetFlag.mjs";
const useGetDecision = (flag) => {
  const decision = useGetFlag(flag);
  const { enabled, variationKey } = decision;
  const eventMapper = useCallback(() => {
    if (enabled) {
      return {
        experiment_ids: variationKey
      };
    }
    return {};
  }, [enabled, variationKey]);
  return { enabled, variationKey, eventMapper };
};
export {
  useGetDecision
};
